import { useMutation, useQueryClient } from "react-query";

import { crearRegistroRutas, updateRegistroRutas, deleteRegistroRutas} from '../../services/RegistroRutas';

import { toast } from 'react-hot-toast';
const queryKey = "rutas";

export const useRutasMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
   // toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addRuta = useMutation((body) => crearRegistroRutas(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
  const updateRutaD = useMutation(
    (body) => updateRegistroRutas( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeRuta = useMutation((id) => deleteRegistroRutas( id), {
    onSuccess,
    onError,
  });

  return { addRuta, updateRutaD, removeRuta };
};
export default useRutasMutations;